import createAxios from "./axiosHttpMarconi";

export const whatsappConfigService = {
  getWhatsappConfig,
  updateWhatsappConfig,
};

function getWhatsappConfig(franquiciaId) {
  const axios = createAxios();
  const urlPath = `/franquicia/${franquiciaId}/whatsapp-config`;
  return axios.get(urlPath);
}

function updateWhatsappConfig(franquiciaId, body) {
  const axios = createAxios();
  const urlPath = `/franquicia/${franquiciaId}/whatsapp-config`;
  return axios.put(urlPath, body);
}
